<template>
  <div class="chat_model_container">
    <div class="chat_model_header">Chat models</div>
    <div class="chat_model_header_text">
      Select which mode you want your chatbot to be in.
    </div>
    <div class="user_custom_radio">
      <CustomRadio
        name="radio"
        customClass="user_border"
        customClass_flex="user_radio_flex"
        number="Always Starts New Conversation with Human"
        :isChecked="true"
        customClass_header="chat_custom_header"
        customClass_desc="chat_custom_desc"
        descriptionText="Every new conversation starts in Human mode. AI won't reply to it."
      />
      <CustomRadio
        customClass="user_border"
        name="radio"
        :isChecked="false"
        customClass_flex="user_radio_flex"
        number="Always Starts New Conversation with AI"
        customClass_header="chat_custom_header"
        customClass_desc="chat_custom_desc"
        descriptionText="Every new conversation starts in AI mode."
      />
    </div>
  </div>
</template>
<script>
import CustomRadio from "../../components/shared/UI/CustomRadio.vue";
export default {
  components: {
    CustomRadio,
  },
};
</script>
<style>
.chat_model_header {
  color: #333;
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}
.chat_model_container {
  max-width: 441px;
  width: 100%;
  padding-top: 36px;
}
.chat_model_header_text {
  color: #bdbdbd;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  padding-top: 8px;
  font-weight: 500;
  line-height: 24px;
}
.chat_custom_header {
  color: #1d1f20;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.chat_custom_desc {
  color: #828282;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
</style>
